import React from 'react';
import ButtonRoot from './Shared/ButtonRoot';

const ButtonSecondarySquare = (props) => {
  return (
    <ButtonRoot 
      className="
        block
        bg-btn-primary
        text-white 
        font-semibold 
        rounded 
        hover:bg-btn-primary-hover
        hover:no-underline
        hover:text-white
      "
      {...props}
    />
  );
};

export default ButtonSecondarySquare;
